import Card from "@material-ui/core/Card";
import { lighten, makeStyles } from "@material-ui/core/styles";
import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { Quest } from "../../../../../zApps/Layout/Login/MyPage/components/OpenableCards/QuestsCard/quests/types";

export function AchievementsCard({
    studyAchievements,
}: {
    studyAchievements: Quest[];
}) {
    const c = useStyles();

    return (
        <Card className={c.achievementsCard} elevation={2}>
            <Card className={c.achievementsTitle}>
                Achievements: {studyAchievements.length}
            </Card>
            {studyAchievements.map(({ questKey, title, transitionTarget }) => (
                <Card
                    key={questKey}
                    className={c.achievementsItem}
                    elevation={3}
                    onClick={() => {
                        if (typeof transitionTarget === "string") {
                            window.open(transitionTarget, "_blank");
                            return;
                        }
                        transitionTarget();
                    }}
                >
                    {title}
                </Card>
            ))}
        </Card>
    );
}

const useStyles = makeStyles(theme => ({
    achievementsCard: {
        padding: 5,
        display: "flex",
        flexWrap: "wrap",
        border: "solid 1px #047c28",
        borderTopLeftRadius: 10,
        fontWeight: "bold",
        overflow: "visible",
    },
    achievementsTitle: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "large",
        margin: "-5px 5px 5px -5px",
        padding: "0 10px",
        borderTopRightRadius: 0,
        borderBottomLeftRadius: 0,
        backgroundColor: "#047c28",
        color: "white",
        fontWeight: "bold",
        position: "relative",
        top: -1,
        left: -1,
    },
    achievementsItem: {
        ...achievementsItemBaseStyle,
        "&:hover": {
            backgroundColor: lighten(theme.palette.primary.light, 0.8),
        },
    },
}));

export const achievementsItemBaseStyle: CSSProperties = {
    display: "inline",
    margin: 5,
    padding: "0 10px",
    width: "auto",
    flexGrow: 0.5,
    maxWidth: 250,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    cursor: "pointer",
};
